import * as XLSX from 'xlsx';
import deliveryService from '../services/deliveryNoteService';

// Server timestamps without an offset are local business times in Casablanca.
export const transactionTime = value => {
  if (!value) return 'Non disponible';
  const iso = String(value).match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/);
  if (iso) return `${iso[3]}/${iso[2]}/${iso[1]} ${iso[4]}:${iso[5]}`;
  const fr = String(value).match(/^(\d{2})[-/](\d{2})[-/](\d{4}) (\d{2}):(\d{2})/);
  return fr ? `${fr[1]}/${fr[2]}/${fr[3]} ${fr[4]}:${fr[5]}` : 'Non disponible';
};

export const exportTransactions = async (filters, cashier = false) => {
  const rows = [];
  let page = 0, totalPages;
  do {
    const response = await (cashier ? deliveryService.listComptoire : deliveryService.list)({ ...filters, page, size: 250 });
    const body = response.body || response;
    if (!Array.isArray(body.content)) throw new Error('Réponse de ventes invalide');
    rows.push(...body.content);
    totalPages = body.totalPages;
    page += 1;
  } while (page < totalPages);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(rows.map(row => ({
    Document: row.numero,
    'Date et heure': transactionTime(row.createdAt),
    'Session ID': row.shiftId ?? '',
    'Session de caisse': row.shiftCode || 'Sans session',
    'Ouverture': transactionTime(row.shiftOpeningTime),
    'Clôture': transactionTime(row.shiftClosingTime),
    Client: row.clientNom || 'Passager',
    Statut: row.status,
    'Montant HT': row.montantTotalHT,
    'Montant TTC': row.montantTotalTTC,
    'Montant payé': row.montantPaye,
  }))), 'Ventes');
  XLSX.writeFile(workbook, 'ventes-sessions.xlsx');
};
